import { Chip } from '@mui/material';

const PRIORIDAD_MAP = {
  BAJA:    { label: 'Baja',    bg: '#F3F4F6', color: '#374151' },
  MEDIA:   { label: 'Media',   bg: '#DBEAFE', color: '#1E40AF' },
  ALTA:    { label: 'Alta',    bg: '#FEF3C7', color: '#92400E' },
  URGENTE: { label: 'Urgente', bg: '#FEE2E2', color: '#991B1B' },
};

const PrioridadChip = ({ prioridad, size = 'small' }) => {
  const config = PRIORIDAD_MAP[prioridad] || { label: prioridad, bg: '#F3F4F6', color: '#374151' };
  return (
    <Chip
      label={config.label}
      size={size}
      sx={{
        bgcolor: config.bg,
        color: config.color,
        fontWeight: 600,
        fontSize: '0.75rem',
        borderRadius: 0,
      }}
    />
  );
};

export default PrioridadChip;
